import * as React from 'react';
import Typography from '@mui/material/Typography';
import { newLineParser } from "../utils";
import { getExcerciseChoiceConfig } from "../utils";
import TranscriptionVideo from '../components/TranscriptionVideo';
import Slide from '@mui/material/Slide';
import { Choices } from '../enums';


export default function IntroductionExcerciseResponsePage({ pageId, excerciseId, choice, showfeedback, showOtherVideo, setNextPageButtonVisible }) {

  const [feedbackVisible, setFeedbackVisible] = React.useState(false);
  let choiceConfig = getExcerciseChoiceConfig(pageId, excerciseId, choice);
  let otherChoice = choice == Choices.A ? Choices.B : Choices.A
  let otherChoiceConfig = getExcerciseChoiceConfig(pageId, excerciseId, otherChoice);

  const showfeedbackOnEnded = () => {
    setFeedbackVisible(true);
  }

  const containerRef = React.useRef(null);

  let Feedback = () => (
    <Typography variant="body2" gutterBottom style={{ whiteSpace: "pre-line" }}>
      {newLineParser(choiceConfig['feedback'])}
    </Typography>

  );



  return (
    <React.Fragment>
      <Typography variant="h5" gutterBottom>
        Feedback
      </Typography>

      <Feedback />

    </React.Fragment>
  );
}
